export enum MxColumnPosition {
  Start = 0,
  Center = 10,
  End = 20,
  Between = 40,
  Arround = 50,
  Evenly = 60,
}
